// @flow

import { Platform } from "react-native-web";

export default () => {
  const bodyTheme = {
    flex: 1,
    flexBasis: Platform.OS === "web" ? "auto" : undefined,
    alignItems: 'center',
    alignSelf: 'center'
  };

  return bodyTheme;
};
